"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _text = require("@mmc/text");
var _clsx = _interopRequireDefault(require("clsx"));
var _pfaHero = _interopRequireDefault(require("./pfa-hero.css"));
var _pfaHero2 = _interopRequireDefault(require("./pfa-hero.props/pfa-hero.defaultProps"));
var _pfaHero3 = _interopRequireDefault(require("./pfa-hero.props/pfa-hero.propTypes"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; } // We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
var PFAHeroTextBlock = function PFAHeroTextBlock(_ref) {
  var data = _ref.data,
    isCarousel = _ref.isCarousel;
  var _ref2 = data || {},
    iconImage = _ref2.logoURL,
    subtitle = _ref2.headingSmall,
    title = _ref2.headingLarge,
    description = _ref2.description,
    disclaimerData = _ref2.disclaimerData,
    ctaLinks = _ref2.ctas,
    mksTagId = _ref2.mksTagId;
  var renderCtas = function renderCtas(mksTagId) {
    var handleClick = function handleClick(_ref3) {
      var label = _ref3.label,
        mksTagId = _ref3.mksTagId;
      var modelName = '';
      if (window.location && window.location.pathname) {
        var pathnames = window.location.pathname.split('/');
        var pathnamePosition = pathnames.length >= 3 ? 2 : 1;
        // eslint-disable-next-line prefer-destructuring
        modelName = pathnames[pathnamePosition];
      }
      window.dataLayer.push(_objectSpread(_objectSpread({
        event: 'linkclickevent',
        section_name: mksTagId,
        component: !isCarousel ? 'PFA' : 'Carousel PFA',
        action: 'CTA click',
        click_text: label
      }, isCarousel && {
        component_heading: title
      }), {}, {
        nameplate: isCarousel ? '' : modelName
      }));
    };
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (ctaLinks == null ? void 0 : ctaLinks.length) > 0 && /*#__PURE__*/_react["default"].createElement("div", {
      className: _pfaHero["default"]['ctas-container']
    }, ctaLinks.map(function (_ref4) {
      var label = _ref4.label,
        link = _ref4.link,
        backgroundCTA = _ref4.backgroundCTA,
        openNewTab = _ref4.openNewTab;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _pfaHero["default"]['cta-container']
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: link,
        onClick: function onClick() {
          return handleClick({
            label: label,
            mksTagId: mksTagId
          });
        },
        className: (0, _clsx["default"])(_pfaHero["default"].cta, _pfaHero["default"][backgroundCTA]),
        target: openNewTab ? '_blank' : ''
      }, label));
    })));
  };
  var renderTextBlock = function renderTextBlock(description) {
    var convertDescription = description !== "" ? description.split('<br>') : description;
    var windowSize = window.innerWidth;
    if (windowSize < 950) {
      var descriptionText = description.replace(/<br\s*\/?>/gi, '');
      return /*#__PURE__*/_react["default"].createElement(_text.Text, {
        className: (0, _clsx["default"])(_pfaHero["default"]['pfa-hero-description']),
        text: descriptionText,
        tag: "p",
        disclaimerData: disclaimerData
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, convertDescription && convertDescription.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, convertDescription.map(function (desc, index) {
      return /*#__PURE__*/_react["default"].createElement(_text.Text, {
        key: index,
        className: (0, _clsx["default"])(_pfaHero["default"]['pfa-hero-description'], convertDescription.length - 1 === index && _pfaHero["default"]['pfa-hero-description-last']),
        text: desc,
        tag: "p",
        disclaimerData: disclaimerData
      });
    })));
  };
  var renderHeroContent = function renderHeroContent() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, iconImage && /*#__PURE__*/_react["default"].createElement("figure", {
      className: _pfaHero["default"]['top-safety-image']
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: iconImage || '/awards.svg'
    })), subtitle && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      className: _pfaHero["default"].subtitle,
      text: subtitle,
      tag: "p",
      disclaimerData: disclaimerData
    }), title && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      className: _pfaHero["default"].title,
      text: title,
      tag: "h1",
      disclaimerData: disclaimerData
    })), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderTextBlock(description), renderCtas(mksTagId)));
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("section", {
    className: _pfaHero["default"]['hero-content']
  }, renderHeroContent()));
};
PFAHeroTextBlock.displayName = 'PFAHeroTextBlock';
PFAHeroTextBlock.defaultProps = {
  data: _pfaHero2["default"]
};
var _default = PFAHeroTextBlock;
exports["default"] = _default;